import React from 'react';

const Settingscontext = React.createContext({})

export default Settingscontext;